// temp solution until a proper versioning
export var UFO_BUILD_VERSION = '0.1.7';